import { Button } from 'antd';
import styled from 'styled-components';

export const ButtonContainer = styled(Button)`
  width: 48px !important;
  height: 48px !important;
  position: fixed;
  z-index: 999;
  right: 32px;
  bottom: 32px;
  border-radius: 50% !important;
  color: ${({ theme }) => theme.colors};
  background: ${({ theme }) => theme.colors.green};
  display: grid;
  place-items: center;
  border: 2px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shapes.boxShadow};

  transition: 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.green};
    transform: scale(1.1);
  }

  > svg {
    width: 2rem;
    height: 2rem;
  }
`;
